import AdminUpgradeFeatures from './AdminUpgradeFeatures';

export default AdminUpgradeFeatures;
